import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] px-6 py-20 md:px-12">
    <div className="mx-auto max-w-[1600px]">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="font-serif-lux text-5xl font-light text-[#f5f5f0]">1of1</p>
          <p className="mt-4 max-w-sm text-sm font-light leading-relaxed text-[#a1a1aa]">
            A private marketplace for objects that exist exactly once. Art, motorcars,
            haute couture and rare jewellery — each verified, each singular.
          </p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#52525b]">Explore</p>
          <ul className="mt-4 space-y-3 text-sm font-light text-[#a1a1aa]">
            <li><Link to="/marketplace" className="hover:text-[#f5f5f0]">The Collection</Link></li>
            <li><a href="/#manifesto" className="hover:text-[#f5f5f0]">Manifesto</a></li>
            <li><a href="/#register" className="hover:text-[#f5f5f0]">Consign a piece</a></li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#52525b]">Contact</p>
          <ul className="mt-4 space-y-3 text-sm font-light text-[#a1a1aa]">
            <li>concierge@1of1.com</li>
            <li>By appointment only</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-[10px] uppercase tracking-[0.25em] text-[#52525b] md:flex-row">
        <span>© 2026 1of1 — All pieces are unique</span>
        <span>Verified provenance · Private client</span>
      </div>
    </div>
  </footer>
);
